import axios from 'axios';
import type { MKEERAApiResponseItem } from '../../features/ApplicationForm/FormConfig/MKEERA/MkEERADashboard/dashboard.types';
import { baseUrl, HttpMethods } from '../base';

export interface MKEERAPublicDataResponse {
  data: MKEERAApiResponseItem[];
  meta: {
    count: number;
  };
}

/**
 * Fetches public MKEERA dashboard data from the Rover applications endpoint
 * @param applicationId - The application ID for MKEERA applications (varies by environment)
 * @param perPage - Number of records per page (default 500)
 * @param page - Page number (default 1)
 * @returns Promise with the applications data
 */
export async function getMKEERAPublicData({
  applicationId,
  perPage = 500,
  page = 1,
}: {
  applicationId: string;
  perPage?: number;
  page?: number;
}): Promise<MKEERAPublicDataResponse> {
  const response = await axios.request<MKEERAPublicDataResponse>({
    method: HttpMethods.GET,
    url: `${baseUrl.TERMINAL}/rover/applications/public`,
    params: {
      formId: applicationId,
      perPage,
      page,
    },
  });

  return response.data;
}
